import React from 'react'
import { useTranslation } from 'react-i18next'

import Organization from '~/models/organization'

import { GeneralIconTag, OrganizationIconTag } from '~/common/define/icon'
import { organizationBasePath } from '~/common/define/path'
import OrganizationHeaderFrame from '~/components/molecules/header/organization/OrganizationHeaderFrame'
import OrganizationHeaderItems from '~/components/molecules/header/organization/OrganizationHeaderItems'
import OrganizationHeaderTextButton from '~/components/molecules/header/organization/OrganizationHeaderTextButton'
import OrganizationHeaderName from '~/components/molecules/header/organization/OrganizationHeaderName'
import ModelsIcon from '~/components/atoms/icon/ModelsIcon'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import OrganizationHeaderIcons from '~/components/molecules/header/organization/OrganizationHeaderIcons'
import OrganizationHeaderPull from '~/components/molecules/header/organization/OrganizationHeaderPull'
import SettingDropdown from '~/components/layout/header/dropdown/SettingDropdown'
import OrganizationDropdown from '~/components/layout/header/dropdown/OrganizationDropdown'
import SearchDropdown from '~/components/layout/header/dropdown/SearchDropdown'
import OpinionDropdown from '~/components/layout/header/dropdown/OpinionDropdown'
import AppNotificationBar from '~/components/layout/header/AppNotificationBar'
import SupportDropdown from '~/components/layout/header/dropdown/SupportDropdown'

interface Props {
  organization: Organization
  isOrigin?: boolean
}

const OrganizationHeader = ({organization, isOrigin = false}: Props) => {
  const {t} = useTranslation('header')

  return (
    <>
      <OrganizationHeaderFrame isOrigin={isOrigin}>
        <OrganizationHeaderItems>
          <OrganizationHeaderTextButton link={organization ? organizationBasePath(organization) : null}>
            {t('header:dashboard')}
          </OrganizationHeaderTextButton>
          <OrganizationHeaderName name={organization ? organization.name : ''} isOrigin={isOrigin}>
            {organization &&
              <ModelsIcon
                image={organization.icon_image}
                tag={organization.icon_tag}
                size={isOrigin ? IconSize.LARGE : IconSize.M_LARGE}
                frame={organization.icon_image ? IconFrame.SQUARE : null}
                bgColor={organization.icon_image ? IconColor.WHITE : null}
              />
            }
          </OrganizationHeaderName>
        </OrganizationHeaderItems>
        <OrganizationHeaderItems>
          {isOrigin &&
            <OpinionDropdown>
              <OrganizationHeaderTextButton pull>
                {t('header:service_improvement')}
              </OrganizationHeaderTextButton>
            </OpinionDropdown>
          }
          <OrganizationHeaderIcons>
            {organization &&
              <SearchDropdown organization={organization} alwaysActive={!isOrigin}/>
            }
            {isOrigin &&
              <SupportDropdown>
                <Icon tag={GeneralIconTag.HELP} size={IconSize.M_SMALL} frame={IconFrame.CIRCLE}
                      bgColor={IconColor.WHITE} clickableColor={IconColor.WHITE}/>
              </SupportDropdown>
            }
            <SettingDropdown isOrigin={isOrigin}>
              <Icon tag={GeneralIconTag.GEAR} size={IconSize.M_SMALL} frame={IconFrame.CIRCLE}
                    bgColor={IconColor.WHITE} clickableColor={IconColor.WHITE}/>
            </SettingDropdown>
            {organization && isOrigin &&
              <OrganizationDropdown organization={organization}>
                <OrganizationHeaderPull>
                  <Icon tag={OrganizationIconTag.BUILDING} size={IconSize.M_LARGE} frame={IconFrame.SQUARE}
                        bgColor={IconColor.WHITE} clickableColor={IconColor.WHITE}/>
                </OrganizationHeaderPull>
              </OrganizationDropdown>
            }
          </OrganizationHeaderIcons>
        </OrganizationHeaderItems>
      </OrganizationHeaderFrame>
      {isOrigin &&
        <AppNotificationBar/>
      }
    </>
  )
}

export default OrganizationHeader